

import {
  ADD_FILEUPLOAD_START,
  ADD_FILEUPLOAD_SUCCESS,
  ADD_FILEUPLOAD_FAILURE,
  ADD_FILEUPLOAD_RESET,
  ADD_CUSTFILEUPLOAD_START,
  ADD_CUSTFILEUPLOAD_SUCCESS,
  ADD_CUSTFILEUPLOAD_FAILURE,
  ADD_CUSTFILEUPLOAD_RESET,
  ADD_POLICYFILEUPLOAD_START,
  ADD_POLICYFILEUPLOAD_SUCCESS,
  ADD_POLICYFILEUPLOAD_FAILURE,
  ADD_POLICYFILEUPLOAD_RESET,
  GET_LEADS_BULKUPLOADS,
  GET_LEADS_BULKUPLOADS_SUCCESS,
  GET_LEADS_BULKUPLOADS_FAILED,
  REVERT_BULK_UPLOAD,
  REVERT_BULK_UPLOAD_SUCCESS,
  REVERT_BULK_UPLOAD_FAILED,
  GET_CUST_BULKUPLOAD,
  GET_CUST_BULKUPLOAD_SUCCESS,
  GET_CUST_BULKUPLOAD_FAILED,
  GET_POLICY_BULKUPLOAD,
  GET_POLICY_BULKUPLOAD_SUCCESS,
  GET_POLICY_BULKUPLOAD_FAILED,
  GET_LIFE_BULKPOLICIES,
  GET_LIFE_BULKPOLICIES_SUCCESS,
  GET_LIFE_BULKPOLICIES_FAILED,
  ADD_MUTUALFUNDFILEUPLOAD_START,
  ADD_MUTUALFUNDFILEUPLOAD_SUCCESS,
  ADD_MUTUALFUNDFILEUPLOAD_FAILURE,
  ADD_MUTUALFUNDFILEUPLOAD_RESET,
  REVERT_MUTUALFUND_BULK_UPLOAD,
  REVERT_MUTUALFUND_BULK_UPLOAD_SUCCESS,
  REVERT_MUTUALFUND_BULK_UPLOAD_FAILED,
  GET_MUTUALFUND_BULKUPLOADS,
  GET_MUTUALFUND_BULKUPLOADS_SUCCESS,
  GET_MUTUALFUND_BULKUPLOADS_FAILED
} from "./actiontypes"



export const addFileUploadStart = (payload) =>
({

  type: ADD_FILEUPLOAD_START,
  payload,
})
export const addFileUploadSuccess = (payload) => ({
  type: ADD_FILEUPLOAD_SUCCESS,
  payload: payload,
});

export const addFileUploadFailure = (error) => ({
  type: ADD_FILEUPLOAD_FAILURE,
  payload: error,
});

export const addFileUploadReset = () => ({
  type: ADD_FILEUPLOAD_RESET,
});



export const addCustFileUploadStart = (payload) =>
({
  type: ADD_CUSTFILEUPLOAD_START,
  payload,
})
export const addCustFileUploadSuccess = (payload) => ({
  type: ADD_CUSTFILEUPLOAD_SUCCESS,
  payload: payload,
});

export const addCustFileUploadFailure = (error) => ({
  type: ADD_CUSTFILEUPLOAD_FAILURE,
  payload: error,
});

export const addCustFileUploadReset = () => ({
  type: ADD_CUSTFILEUPLOAD_RESET,
});



export const addPolicyFileUploadStart = (payload) =>
({
  type: ADD_POLICYFILEUPLOAD_START,
  payload,
})
export const addPolicyFileUploadSuccess = (payload) => ({
  type: ADD_POLICYFILEUPLOAD_SUCCESS,
  payload: payload,
});

export const addPolicyFileUploadFailure = (error) => ({
  type: ADD_POLICYFILEUPLOAD_FAILURE,
  payload: error,
});

export const addPolicyFileUploadReset = () => ({
  type: ADD_POLICYFILEUPLOAD_RESET,
});


export const getLeadsBulkUploads = () => ({
  type: GET_LEADS_BULKUPLOADS
})

export const getLeadsBulkUploadsSuccess = (payload) => ({
  type: GET_LEADS_BULKUPLOADS_SUCCESS,
  payload
})

export const getLeadsBulkUploadsFailed = (payload) => ({
  type: GET_LEADS_BULKUPLOADS_FAILED,
  payload
})

export const revertBulkUpload = payload => ({
  type: REVERT_BULK_UPLOAD,
  payload
})

export const revertBulkUploadSuccess = payload => ({
  type: REVERT_BULK_UPLOAD_SUCCESS,
  payload
})

export const revertBulkUploadFailed = payload => ({
  type: REVERT_BULK_UPLOAD_FAILED,
  payload
})


export const getCustBulkUpload = () =>({
  type: GET_CUST_BULKUPLOAD
})

export const getCustBulkUploadSuccess = (payload) =>({
  type: GET_CUST_BULKUPLOAD_SUCCESS,
  payload
})

export const getCustBulkUploadFailed = (payload) =>({
  type: GET_CUST_BULKUPLOAD_FAILED,
  payload
})


export const getPolicyBulkUpload = () =>({
  type: GET_POLICY_BULKUPLOAD
})

export const getPolicyBulkUploadSuccess = (payload) =>({
  type: GET_POLICY_BULKUPLOAD_SUCCESS,
  payload
})

export const getPolicyBulkUploadFailed = (payload) =>({
  type: GET_POLICY_BULKUPLOAD_FAILED,
  payload
})


export const getLifeBulkPolicies = (payload) =>({
  type: GET_LIFE_BULKPOLICIES,
  payload
})

export const getLifeBulkPoliciesSuccess = (payload) =>({
  type: GET_LIFE_BULKPOLICIES_SUCCESS,
  payload
})

export const getLifeBulkPoliciesFailed = (payload) =>({
  type: GET_LIFE_BULKPOLICIES_FAILED,
  payload
})

export const addMutualFundFileUploadStart = (payload) =>
({
  type: ADD_MUTUALFUNDFILEUPLOAD_START,
  payload,
})
export const addMutualFundFileUploadSuccess = (payload) => ({
  type: ADD_MUTUALFUNDFILEUPLOAD_SUCCESS,
  payload: payload,
});

export const addMutualFundFileUploadFailure = (error) => ({
  type: ADD_MUTUALFUNDFILEUPLOAD_FAILURE,
  payload: error,
});

export const addMutualFundFileUploadReset = () => ({
  type: ADD_MUTUALFUNDFILEUPLOAD_RESET,
});

export const revertMutualFundBulkUpload = payload => ({
  type: REVERT_MUTUALFUND_BULK_UPLOAD,
  payload
})

export const revertMutualFundBulkUploadSuccess = payload => ({
  type: REVERT_MUTUALFUND_BULK_UPLOAD_SUCCESS,
  payload
})

export const revertMutualFundBulkUploadFailed = payload => ({
  type: REVERT_MUTUALFUND_BULK_UPLOAD_FAILED,
  payload
})

export const getMutualFundBulkUploads = () => ({
  type: GET_MUTUALFUND_BULKUPLOADS
})

export const getMutualFundBulkUploadsSuccess = (payload) => ({
  type: GET_MUTUALFUND_BULKUPLOADS_SUCCESS,
  payload
})

export const getMutualFundBulkUploadsFailed = (payload) => ({
  type: GET_MUTUALFUND_BULKUPLOADS_FAILED,
  payload
})